/*
 * Copyright (c) 2026.
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden volgens de voorwaarden die zijn vastgelegd in een bijbehorende schriftelijke overeenkomst met Spin in het Web B.V.
 */

/**
 * Auteur: Jelmer Jellema - Spin in het Web B.V.
 * Gegenereerd met Junie (AI), 03-06-2026
 *
 * Cytoscape stylesheet voor de simulatiecanvas. Vervangt de AngularJS-constante
 * `cytoSimStyle` uit `app/cytostyles/simcytostyle.js`. Wordt door
 * `DlSimCanvasComponent` meegegeven aan Cytoscape bij init.
 */
import type { StylesheetJson } from 'cytoscape';

// De Cytoscape-typings voor Css.Core/Node/Edge zijn streng en eisen properties die
// runtime niet vereist zijn; daarom typeren we de array als StylesheetJson via cast.
export const cytoSimStyle: StylesheetJson = [
    // core
    { selector: 'core', css: { 'outside-texture-bg-color': '#fff' } },

    // node basis
    {
        selector: 'node',
        css: {
            'shape': 'ellipse',
            'text-halign': 'right',
            'text-valign': 'center',
            'font-size': 25,
            'width': 50,
            'height': 50,
            'background-color': 'white',
            'background-fit': 'contain',
            'background-repeat': 'no-repeat'
        }
    },

    // node.state label en kleur
    {
        selector: 'node.state',
        css: {
            'label': 'data(num)',
            'text-halign': 'center',
            'text-valign': 'center',
            'color': 'white'
        }
    },

    // node.state status varianten
    { selector: 'node.state[status = "open"]', css: { 'background-image': 'resources/img/simnodes/state_unprocessed.svg' } },
    { selector: 'node.state[status = "open"]:selected', css: { 'background-image': 'resources/img/simnodes/state_unprocessed_selected.svg' } },

    { selector: 'node.state[status = "terminated"]', css: { 'background-image': 'resources/img/simnodes/state_terminated.svg' } },
    { selector: 'node.state[status = "terminated"]:selected', css: { 'background-image': 'resources/img/simnodes/state_terminated_selected.svg' } },

    { selector: 'node.state[status = "ordered"]', css: { 'background-image': 'resources/img/simnodes/state_ordered.svg' } },
    { selector: 'node.state[status = "ordered"]:selected', css: { 'background-image': 'resources/img/simnodes/state_ordered_selected.svg' } },

    { selector: 'node.state[status = "closed"]', css: { 'background-image': 'resources/img/simnodes/state_closed.svg' } },
    { selector: 'node.state[status = "closed"]:selected', css: { 'background-image': 'resources/img/simnodes/state_closed_selected.svg' } },

    // scenario
    { selector: 'node.scenario', css: { 'background-image': 'resources/img/simnodes/scenario.svg' } },
    { selector: 'node.scenario:selected', css: { 'background-image': 'resources/img/simnodes/scenario_selected.svg' } },

    // transitie nodes
    {
        selector: 'node.transitie',
        css: {
            'width': 20,
            'height': 20,
            'background-image': 'resources/img/simnodes/termination.svg'
        }
    },
    { selector: 'node.transitie:selected', css: { 'background-image': 'resources/img/simnodes/termination_selected.svg' } },

    // edges basis
    {
        selector: 'edge',
        css: {
            'curve-style': 'bezier'
        }
    },

    // edge.nextstate
    {
        selector: 'edge.nextstate',
        css: {
            'line-color': 'grey',
            'width': 1,
            'line-style': 'solid',
            'target-arrow-shape': 'triangle',
            'target-arrow-color': 'grey'
        }
    },

    // edge.transition
    {
        selector: 'edge.transition',
        css: {
            'line-color': '#eee',
            'width': 1,
            'line-style': 'solid'
        }
    },

    // lijn tussen 2 geselecteerde states die op route liggen
    {
        selector: 'edge.inSelected.outSelected.opRoute',
        css: {
            'line-color': '#02c700',
            'target-arrow-color': '#02c700',
            'width': 3
        }
    }
] as unknown as StylesheetJson;
